import React, { Component } from 'react'
import FirstViewlist from '../firstviewlist'
import * as styles from './firstview.module.css'

export default class FirstView extends Component {

  render() {
    return (
      <div className={styles.firstview}>
        <p className={styles.firstview_h2}>おすすめ記事 ＆ ピックアップ記事</p>
        <div className={styles.firstview_contents}>
          {/* １列目 */}
          <FirstViewlist target={'titifuckactress'} />
          <FirstViewlist target={'titifuckbest'} />
          <FirstViewlist target={'debut'} />
          <FirstViewlist target={'pzyear'} />
          {/* ２列目 */}
          {/* 2025-06-03 23:59 */}
          <FirstViewlist target={'gvh00545'} />
          <FirstViewlist target={'1start00231'} />
          <FirstViewlist target={'83sma00714'} />
          <FirstViewlist target={'83sma00704'} />
          {/* ３列目 */}
          <FirstViewlist target={'sone00201'} />
          <FirstViewlist target={'ofje00150'} />
          <FirstViewlist target={'1stars00789'} />
          <FirstViewlist target={'1stars00906'} />
          {/* ４列目 */}
          {/* 2025-06-03 23:59 */}
          <FirstViewlist target={'vrkm01167'} />
          <FirstViewlist target={'sone00199'} />
          <FirstViewlist target={'duga'} />
          <FirstViewlist target={'cospa'} />
        </div>
      </div>
    )
  }
}